import { render, staticRenderFns } from "./vip-secret.vue?vue&type=template&id=5ca92854&scoped=true&"
import script from "./vip-secret.vue?vue&type=script&lang=js&"
export * from "./vip-secret.vue?vue&type=script&lang=js&"
import style0 from "./vip-secret.vue?vue&type=style&index=0&id=5ca92854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca92854",
  null
  
)

export default component.exports